/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TSetOfferLabelModel,
  ISetOfferLabelRequest,
  IMappers,
  ISetOfferLabelResponse,
  ISetOfferLabelResponseError,
  TSetOfferLabelResponse,
} from './types';

const defaultConfig: TSetOfferLabelModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'e2e-deal-entrypoints',
  pathApi: '/v1/set-offer-label/',
  hostType: 'api',
} as TSetOfferLabelModel;

function createSetOfferLabelModel(parameters: ISetOfferLabelRequest): TSetOfferLabelModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISetOfferLabelOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ISetOfferLabelRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchSetOfferLabel<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ISetOfferLabelOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TSetOfferLabelResponse> {
  const { response, statusCode } = await httpApi.fetch(createSetOfferLabelModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISetOfferLabelResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ISetOfferLabelResponseError);
    }
  }

  return { response, statusCode } as TSetOfferLabelResponse;
}

export { defaultConfig, createSetOfferLabelModel, fetchSetOfferLabel };
